import React from 'react';
import {SearchField, DataGrid, RaymanUser, UserSize, FilterMenu, Text, SmartDateLabel, SmartTagText, IconMenu} from 'components/core';
import {Grid} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';
// import clsx from 'clsx';
import {OperationsCtx} from 'components/dataProviders/operations';
import {TagsCtx} from 'components/dataProviders/tags';
import Singletons from 'controllers/Singletons';
import EditDialog from './edit';
import clsx from 'clsx';

const overrideStyle = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        height: '100%'
    },
    toolbar: {
        padding: 24,
        height: 88,
        boxSizing: 'border-box',
        flexGrow: 0,
        flexShrink: 0,
        flexBasis: 88,
        '& .MuiGrid-item':
        {
            height: 40
        },
        '& .MuiTypography-root':
        {
            lineHeight: '40px'
        }
    },
    datagrid: {
        height: 'calc(100% - 88px)',
        '& .Mui-selected $idField':
        {
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.background.paper,
            '&.disabled': {
                color: theme.palette.background.default,
                backgroundColor: theme.palette.text.secondary
            }
        },
    },
    searchbox: {
        height: 40,
        width: 300
    },
    idField: {
        backgroundColor: theme.palette.secondary.main,
        color: theme.palette.primary.main,
        borderRadius: 4,
        padding: '2px 8px',
        minWidth: 42,
        height: 24,
        textAlign: 'center',
        lineHeight: '24px',
        '&.disabled': {
            backgroundColor: theme.palette.background.default,
            color: theme.palette.text.secondary
        }
    },    
    notifications: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.secondary.main,
        borderRadius: 4,
        padding: '2px',
        minWidth: 20,
        height: 20,
        marginLeft: 15,
        textAlign: 'center',
        lineHeight: '18px',
        fontSize: 13
    }
  }), {name: "RaymanDataGrid"});

  
function IDField(props)
{
    const classes = overrideStyle();
    return <span className={clsx(classes.idField, props.disabled? "disabled" : "")}>{props.children}</span>
}

function NotificationBadge(props)
{
    const classes = overrideStyle();
    return <span className={classes.notifications}>{props.children}</span>
}

function RowMenu({row, handleEdit, dataset})
  {
      const ctx = React.useContext(OperationsCtx);
    
      function handleArchive()
      {
          if(dataset === "open")
          {
            ctx.funcs.disable(row.operationID);
          }
          else
          {
            ctx.funcs.enable(row.operationID);
          }
      }
      let items = [
        {
            label: "Editar",
            onClick: () => handleEdit()
        },
        {
            label: dataset === "open" ? "Archivar" : "Desarchivar",
            onClick: () => handleArchive(),
            danger: dataset === "open",
            disabled: ctx.data.indexed[row.operationID].currentUserRole === "operator" && !Singletons.userProfiles.admin
        } 
      ];
      return <>
      <IconMenu items={items} />
      </>
  }

const columns = {
    id: {
        field: 'id', 
        headerName: 'ID',
        width: 90,
        align: 'center',
        headerAlign: 'center',
        renderCell: (params) => {
            return <IDField disabled={params.row.closed}>{params.value}</IDField>
        }
    },
    name: { 
        field: 'name',
        headerName: 'Nombre del ticket',
        flex: 1,
        // renderCell: (params) => {
    
        // }
    },
    operator: {
        field: 'operator',
        headerName: 'Operario',
        flex: 0.5,
        renderCell: (params) => {
            return <RaymanUser userID={params.value} size={UserSize.size32} />
        }
    },
    expert: {
        field: 'expert',
        headerName: 'Experto',
        flex: 0.5,
        renderCell: (params) => {
            return <RaymanUser userID={params.value} size={UserSize.size32} />
        }
    },
    tags: {
        field: 'tags',
        headerName: 'Etiquetas',
        flex: 0.5,
        renderCell: (params) => {
            return <SmartTagText tagIDs={params.value} />
        }
    },
    lastMessage: {
        field: 'lastMessage',
        headerName: 'Ult. mensaje',
        width: 170,
        align: 'right',    
        headerAlign: 'right',
        renderCell: (params) => {
            return <>
            <SmartDateLabel unformatted datetime={params.value} />
            {params.row.notifications ? <NotificationBadge>{params.row.notifications}</NotificationBadge> : null}
            </>;
        }
    },
    closed: {
        field: 'closeDatetime',
        headerName: 'Cerrado',
        width: 170,
        align: 'right',    
        headerAlign: 'right',
        renderCell: (params) => {
            return <>
            <SmartDateLabel unformatted datetime={params.value} />
            </>;
        }
    }
}

const collapsedColumns = [columns.id, columns.name, columns.tags, columns.lastMessage];
const extendedColumns = [columns.id, columns.name, columns.operator, columns.expert, columns.tags, columns.lastMessage];

const usersFilter = [
    {value: true, text: "Ver sólo mis tickets", overrideLabel: "Mis tickets"},
    {value: false, text: "Ver todos los tickets", overrideLabel: "Todos los tickets"}
]


export default function OperationsList({onRowSelected = () => {}, collapsed = false, dataset="open"})
{
    const classes = overrideStyle();
    const opsCtx = React.useContext(OperationsCtx);
    const tagsCtx = React.useContext(TagsCtx);
    const [data, setData] = React.useState(opsCtx.data.array);
    const [filters, setFilters] = React.useState({text: '', tags: [], user: false, closed: dataset === "closed"});
    const [gridColumns, setGridColumns] = React.useState([]);
    const [userFilterElem, setUserFilterElem] = React.useState(null);
    const [filterTags, setFilterTags] = React.useState([]);
    const [editDialogState, setEditDialogState] = React.useState({open: false, operationID: null});

    const menuColumn = React.useMemo(() => ({
        field: 'menu',
        headerName: ' ',
        width: 40,
        align: 'center',
        disableClickEventBubbling: true,
        renderCell: (params) => {
            return <RowMenu row={params.row} handleEdit={() => setEditDialogState({open: true, operationID: params.row.operationID})} dataset={dataset}/>
        }
    }), [dataset]);

    let searchTimeout = 0;

    React.useEffect(function filterData(){
        
        let tmpData = [...opsCtx.data.array];
        
        // apply filters
        tmpData = tmpData.filter((value) => {
            let result = true;
            if(filters.text) result &= value.name.toLowerCase().includes(filters.text);
            if(filters.tags.length > 0) result &= value.tags.some(r => filters.tags.includes(r));            
            if(filters.user) result &= (value.operator === filters.user || value.expert === filters.user);
            result &= (value.closed === (dataset === "closed"));
            return result;
        });

        setData(tmpData);
    }, [opsCtx, dataset, filters]);

    React.useEffect(function initializeFilterTags() {
        let tags = [];
        tagsCtx.data.array.forEach((item) => tags.push({value: item.tagID, text: item.name}));

        setFilterTags(tags);
    }, [tagsCtx]);

    React.useEffect(function handleColumns(){
        let gridCols = collapsed ? [...collapsedColumns] : [...extendedColumns];

        if(Singletons.userProfiles.admin || Singletons.userProfiles.expert) gridCols.push(menuColumn);

        if(dataset === "closed") gridCols.splice(gridCols.length - 2, 1, columns.closed);
        setGridColumns(gridCols);
    }, [dataset, collapsed, menuColumn]);

    const handleSelectRow = (row) =>
    {
        onRowSelected(row);
    }

    const handleSearchChange = (value) =>
    {
        if(searchTimeout) clearTimeout(searchTimeout);
        searchTimeout = setTimeout(() => {
            let tmpFilters = {...filters};
            tmpFilters.text = value;
            if(tmpFilters.text !== filters.text) setFilters(tmpFilters);
        }, 300);
    }

    const handleTagsChange = React.useCallback((tags) => {
        let tmpFilters = {...filters};
        tmpFilters.tags = tags;
        
        if(tmpFilters.tags.join(",") !== filters.tags.join(","))
        {
            setFilters(tmpFilters);
        }
        
    }, [filters]);

    const handleUsersChange = React.useCallback((users) => {
        let tmpFilters = {...filters};
        if(users[0]) tmpFilters.user = Singletons.currentUser.userID;
        else tmpFilters.user = false;
        if(tmpFilters.user !== filters.user)
        {
            setFilters(tmpFilters);
        }
    }, [filters]);

    React.useEffect(function createUsersFilter() {

        let disabled = true;
        let preselected = 0;

        if(Singletons.currentUser.profiles.length > 1)
        {
            if(Singletons.currentUser.profiles.indexOf("administrators") !== -1)
            {
                disabled = false;
            }
        }
        else
        {
            if(Singletons.currentUser.profiles[0] === "administrators")
            {
                preselected = 1;
            }
        }
        setUserFilterElem(<Grid item><FilterMenu type="radio" disabled={disabled} selectedIndexes = {[preselected]} items={usersFilter} onChange={handleUsersChange}/></Grid>);
    }, [handleUsersChange]);

    function handleEditDialogClose()
    {
        setEditDialogState({open: false, operationID: null});
    }

    let columnSorting = [];
    if(dataset === "open") columnSorting.push({
            field: 'lastMessage',
            sort: 'desc'
        });
    else columnSorting.push({
        field: 'closeDatetime',
        sort: 'desc'
        });

    return <>
        <EditDialog open={editDialogState.open} onClose={()=>handleEditDialogClose()} operationID={editDialogState.operationID} />
        <Grid container direction="row" justify="space-between" className={classes.toolbar}>
            <Grid item><SearchField className={classes.searchbox} onChange={handleSearchChange} /></Grid>
            <Grid item>
                <Grid container direction="row" justify="flex-end" spacing={2}>
                    <Grid item><Text>Filtros:</Text> </Grid>
                    <Grid item><FilterMenu label={"Etiquetas"} items={filterTags} onChange={handleTagsChange}/></Grid>
                    {userFilterElem}
                </Grid> 
            </Grid>
        </Grid>
        <DataGrid 
        rows={data}
        columns={gridColumns}
        onRowSelected = {(row) => handleSelectRow(row.data)}
        loading={opsCtx.loading}
        density="comfortable"
        className={classes.datagrid}
        sortModel={columnSorting}
        />
    </>
}